import GenericMetadataParser from "../../../GenericMetadataParser";

export const Tooltip = ({ metadata }) => (
  <GenericMetadataParser className="tooltip" componentMetadata={metadata} />
);
